import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsDbmodelsService } from './edit-dialogs-dbmodels.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-dbmodels',
  templateUrl: './edit-dialogs-dbmodels.component.html',
  styleUrls: ['./edit-dialogs-dbmodels.component.scss']
})
export class EditDialogsDbmodelsComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsDbmodelsService: EditDialogsDbmodelsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsDbmodelsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsDbmodelsService.build(); }

  ngOnInit() {
    this.editDialogsDbmodelsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Dbmodels
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsDbmodelsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del dbmodel está ausente
      // -1: El número del dbmodel ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorDbmodels('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorDbmodels('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog dbmodels
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let dbmodel = this.editDialogsDbmodelsService.dbmodels;
    let original = this.editDialogsDbmodelsService.originalDbmodels;
    return this.editDialogsDbmodelsService.compare(dbmodel, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorDbmodels(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
